import { useState, useEffect, useCallback } from 'react';
import { Client, CreateClientInput } from '../types';
import * as clientsService from '../services/clients';

export function useClients() {
  const [clients, setClients] = useState<Client[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchClients = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await clientsService.getClients();
      setClients(data);
    } catch (err) {
      setError('Error al cargar los clientes');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  const createClient = async (input: CreateClientInput): Promise<Client> => {
    const client = await clientsService.createClient(input);
    setClients((prev) => [...prev, client]);
    return client;
  };

  const deleteClient = async (id: string): Promise<void> => {
    await clientsService.deleteClient(id);
    setClients((prev) => prev.filter((c) => c.id !== id));
  };

  return {
    clients,
    loading,
    error,
    fetchClients,
    createClient,
    deleteClient,
  };
}
